import React, { useEffect, useState } from 'react';
import { FaFolderOpen } from "react-icons/fa";
import { MdOutlineLibraryAdd } from "react-icons/md";
import Projects from './providers/projects';
import CreateProviderModal from '../Manage/Videos/create_provider_modal';
import NewProviderModal from './providers/Modals/create_provider_modal';
import axios from 'axios';
import EditProviderModal from './providers/Modals/update_provider_modal';
import { MdDeleteForever } from "react-icons/md";
import Swal from 'sweetalert2';
import ClipLoader from 'react-spinners/ClipLoader';
import { AxiosInstance } from '../../common/Loader/axios.config';



export default function Providers() {
    const [openProvider, setOpenProvider] = useState(false);
    const [openProviderModal, setOpenProviderModal] = useState(false);
    const [openEditProviderModal, setOpenEditProviderModal] = useState(false);
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [providers, setProviders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    // const AxiosInstance = axios.create({
    //     baseURL: 'https://dev.staticcomputersinc.com/kanemaonline',
    // });

    const fetchProviders = async (limit = 10, item = "") => {
        let skip = 0;
        let allProviders = [];
        let hasMore = true;

        // Get provider data from localStorage
        const providerData = JSON.parse(localStorage.getItem("provider") || "{}") as { id?: string; userType?: string };
        
        while (hasMore) {
            try {
                const response = await AxiosInstance.get('/providers', {
                    params: {
                        skip,
                        limit,
                        item,
                    },
                });

                if (response.data.status == "unsuccessful") {
                    Swal.fire({
                        icon: 'error',
                        title: 'Failed to fetch providers',
                        text: `${response.data.message}`,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    return;
                }

                const providers = response.data.message;

                console.log("Providers Response", providers);

                allProviders = [...allProviders, ...providers];

                hasMore = providers.length === limit;
                skip += limit;
            } catch (error) {
                console.error('Error fetching providers:', error);
                hasMore = false;
            }
        }

        // Filter providers based on userType
        const filteredProviders = providerData.userType === "admin"
            ? allProviders
            : allProviders.filter(provider => provider._id === providerData.id);

        const sortedProviders = filteredProviders.sort((a, b) => {
            return (
                new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
            );
        });
        setProviders(sortedProviders);
    };

    useEffect(() => {
        fetchProviders();
    }, []);

    const filteredProviders = providers.filter(provider => {
        const searchTermLower = searchTerm.toLowerCase();
        return (
            provider.name.toLowerCase().includes(searchTermLower) ||
            provider.category.toLowerCase().includes(searchTermLower) ||
            provider.price.toString().includes(searchTermLower)
        );
    });

    const handleDeleteProvider = async (ProviderID) => {
        try {
            setLoading(true);
            const response = await AxiosInstance.delete(`/${ProviderID}/content-provider`);
            console.log("Delete Provider Response", response);
            if (response.status == 200) {
                fetchProviders();
                Swal.fire({
                    icon: 'success',
                    title: 'Provider deleted successfully!',
                    text: 'The provider has been deleted successfully.',
                    showConfirmButton: false,
                    timer: 2000,
                });
                setLoading(false);
                setOpenEditProviderModal(false);
            }
        } catch (error) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: 'Failed to delete provider',
                text: 'An error occurred while deleting the provider.',
            });
        }
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    return (
        <div className='w-full flex flex-col items-center justify-start'>
            {openProvider ? (
                <Projects setOpenProvider={setOpenProvider} setSelectedProvider={setSelectedProvider} provider={selectedProvider?._id} />
            ) : (
                <div className='w-full'>
                    <div className="w-full flex items-center justify-between mb-4">
                        <div className="w-1/2">
                            <input
                                type="text"
                                placeholder="Search providers"
                                className="w-full bg-transparent rounded-lg border border-gray-300 px-3 py-1 text-white"
                                value={searchTerm}
                                onChange={handleSearch}
                            />
                        </div>
                        <button className="flex items-center gap-x-1 rounded-lg bg-primary px-3 py-2 text-white duration-200 hover:scale-105"
                            onClick={() => setOpenProviderModal(true)}
                        >
                            <MdOutlineLibraryAdd size={20} />
                            <p className="font-bold text-lg">New</p>
                        </button>
                    </div>

                    <div className="w-full h-[600px] overflow-y-auto">
                        <div className="w-full grid grid-cols-3 gap-4 my-4">
                            {filteredProviders.map((provider) => (
                                <div key={provider._id} className="bg-white text-black rounded-lg shadow-lg p-4 cursor-pointer">
                                    <img src={provider.thumb_nail} alt={provider.name} className="w-full h-40 object-cover mb-4" />
                                    <h3 className="text-lg font-semibold mb-1">{provider.name}</h3>
                                    <p className="text-gray-600 mb-1">{provider.category}</p>
                                    <p className="text-gray-600 mb-1">Price: MWK {provider.price}</p>

                                    <div className="flex items-center gap-x-2">
                                        <button
                                            className="rounded-md bg-primary px-3 py-1 text-white"
                                            onClick={() => {
                                                setSelectedProvider(provider);
                                                setOpenEditProviderModal(true);
                                            }}
                                        >
                                            Edit
                                        </button>

                                        <button
                                            className="flex items-center gap-x-1 rounded-md bg-primary px-3 py-1 text-white"
                                            onClick={() => {
                                                setSelectedProvider(provider);
                                                setOpenProvider(true);
                                            }}
                                        >
                                            <FaFolderOpen size={18} />
                                            Open
                                        </button>

                                        <button className="rounded-md bg-brand-red p-2 text-white hover:scale-105 duration-200"
                                            onClick={() => {
                                                handleDeleteProvider(provider._id);
                                            }}
                                        >
                                            <MdDeleteForever size={18} />
                                        </button>

                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {openProviderModal && <NewProviderModal isOpen={openProviderModal} onClose={() => setOpenProviderModal(false)} fetchProviders={fetchProviders} />}
            {openEditProviderModal && <EditProviderModal isOpen={openEditProviderModal} onClose={() => setOpenEditProviderModal(false)} selectedProvider={selectedProvider} fetchProviders={fetchProviders} />}
        </div>
    )
}
